import { render, staticRenderFns } from "./BatchImportPriceBtn.vue?vue&type=template&id=7f5b6247&scoped=true&"
import script from "./BatchImportPriceBtn.vue?vue&type=script&lang=js&"
export * from "./BatchImportPriceBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5b6247",
  null
  
)

export default component.exports